module.exports = __webpack_public_path__ + "static/media/gadogado_logo.1e014288.png";